import { createSlice } from '@reduxjs/toolkit';
import { CONSUMPTION_TYPES } from 'config/app-config';

export const initialState = {
  data: {
    consumptionType: null
  }
};

export const slice = createSlice({
  name: 'consumptionEntry',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = initialState.data;
    },
    setConsumptionType: (state, { payload }) => {
      state.data.consumptionType = payload;
    }
  }
});

export const { setInitialState, setConsumptionType } = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectSliceData = (state) => selectSlice(state).data;
export const selectConsumptionType = (state) =>
  selectSliceData(state).consumptionType;
export const selectIsDirectConsumption = (state) =>
  selectConsumptionType(state) === CONSUMPTION_TYPES.ACTUAL;

export default slice.reducer;
